
export default {
  props: {
    blok: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      pinSelectedId: '',
    }
  },
  methods: {
    setId(id) {
      this.pinSelectedId = id
    },
    refresh() {
      this.$ScrollTrigger.refresh(true)
    },
  },
}
